/* eslint-disable no-undef */
const HOST = process.env.REACT_APP_API_BASE_URL;
const HOST1 = process.env.REACT_APP_SECONDARY_API_BASE_URL;

export const SERVICES = {
  CONTRIBUTION_LOGIN: `${HOST}/contributionLogin`,
  OTP_AUTHENTICATION: `${HOST}/mfa`,
  MEMBER_DETAILS: (memberId) => `${HOST1}/contribution/api/members/${memberId}`,
  GET_PROFILE: `${HOST}/api/profile`,
  GET_SETTINGS: `${HOST}/api/settings`,
  CONTRIBUTION_FORM: `${HOST1}/contribution/api/orders`,
  JUSPAY_RETURN_URL: `${HOST1}/online-transection-status/contribution/api/public/paymentResponse/juspay`,
  YESBANK_RETURN_URL: `${HOST1}/online-transection-status/contribution/api/public/paymentResponse/easebuzz`,
  ICICIBANK_RETURN_URL: `${HOST1}/contribution/api/public/paymentResponse/eazypay`,
  CONTRIBUTION_DETAILS: (memberId) =>
    `${HOST1}/contribution/api/members/${memberId}/paymentOrders`,
  CONTRIBUTION_HISTORY: (memberId) =>
    `${HOST1}/contribution/api/members/${memberId}/contributionHistory`,
  JUSPAY_REDIRECTION: (orderID) =>
    `${HOST1}/contribution/api/public/paymentResponse/juspay?order_id=${orderID}&status=CHARGED&status_id=21&signature=9pqZMQ5qNu12mCrs4dPAzZLEcWOA%2BQo8rWrILDjhiYA%3D&signature_algorithm=HMAC-SHA256`,
  JUSPAY_POST_REQUEST: `${HOST1}/contribution/api/public/paymentResponse/juspay`,
  GET_MEMBER_DETAILS: `${HOST1}/contribution/api/members`,
  CONTRIBUTION_CYCLE: `${HOST1}/contribution/api/contributionCycles`,
  // Add more services URLs here
};
